<template>
  <select
    class="custom-select bg-gray text-dark text-center br-5 font-weight-normal shadow border-0"
    @change="setOrderType"
    v-model="selectedOrderType"
  >
    <option
      v-if="storeSupportsPickup && !dineInSupported"
      :selected="isPickup"
      :value="pickupString"
    >
      {{ $t("message.pickUp") }}
    </option>
    <option
      v-if="storeSupportsDinein || dineInSupported"
      :selected="isDineIn"
      :value="dineInString"
    >
      {{ tableNumber || $t("message.dineIn") }}
    </option>
    <option
      v-if="storeSupportsDelivery && !dineInSupported"
      :selected="isDelivery"
      :value="deliveryString"
    >
      {{ $t("message.delivery") }}
    </option>
  </select>
</template>

<script>
import { orderTypeHelper } from "../../api/helpers/orderTypeHelper";
import shared from "../../sharedscripts/shop/ordertype/SupportedOrderType";
export default {
  name: "OrderTypeSelect",
  data() {
    return {
      name: "",
      error: false,
      selectedOrderType: "",
    };
  },
  computed: {
    ...shared.computed,
    tableNumber() {
      const tableNumber = sessionStorage.getItem("table");
      if (!tableNumber) {
        return;
      }
      return `Table ${tableNumber}`;
    },
    dineInSupported() {
      return sessionStorage.getItem("table");
    },
  },
  mounted() {
    this.selectedOrderType = orderTypeHelper.getOrderType();
    if (!this.selectedOrderType) {
      if (this.storeSupportsDelivery) {
        orderTypeHelper.setOrderTypeDelivery();
      }
      if (this.storeSupportsDinein) {
        orderTypeHelper.setOrderTypeDineIn();
      }
      if (this.storeSupportsPickup) {
        orderTypeHelper.setOrderTypePickup();
      }
    }
    if (window.orderTypeTimerRef) {
      clearInterval(window.orderTpeTimerRef);
    }
    window.orderTypeTimerRef = setInterval(() => {
      this.selectedOrderType = orderTypeHelper.getOrderType();
    }, 1000);
  },
  methods: {
    ...shared.methods,
  },
};
</script>

<style></style>
